
  // ═══════════════════════════════════════════════════════════════
  // VARIABLES À CUSTOMISER POUR CHAQUE PAGE
  // ═══════════════════════════════════════════════════════════════

  // ── Raccourcis pour les valeurs partagées ────────────────────
  const p     = { x: 0,        y: 0,                    z: 0 };
  const r     = { x: -2.07,    y: -85.83,               z: 0 };
  const o     = { x: 6.777560, y: -0.201442,            z: 0.540162 };

  const p_edp = { x: 0,        y: 0,                    z: 0 };
  const r_edp = { x: 5.61,     y: 5.006,                z: -2.322 };
  const s_edp = 0.7458;
  const o_edp = { x: 4.001033, y: 0.912703,             z: -5.640808 };

  const p_san = { x: 0,        y: 0,                    z: 0 };
  const r_san = { x: -0.774,     y: 73.56,                z: 5.25 };
  const s_san = 0.6618;
  const o_san = { x: 5.940531158320264, y: 1.5128012452833899,  z: -28.2181372705033 };

  const p_mai = { x: 0,        y: 0,                    z: 0 };
  const r_mai = { x: 0.066,     y: 74.178,                z: 0 };
  const s_mai = 0.376;
  const o_mai = { x: -14.80581335126186, y: 1.6369095301623966,  z: -15.623059942583449 };

  // ── Définition par modèle ────────────────────────────────────
  //
  //  Chaque entrée = un modèle. Ordre identique au tableau models[].
  //  Propriétés : url, pos{X,Y,Z}, rot{X,Y,Z}Deg, scale, localOff{X,Y,Z}
  //
  const modelDefs = [

    { // 0 – chomo_complet_1M3_V3
      url:        "./assets/chomo/models/chomo_complet_1M3_V3_hollowed_2.sog",
      posX: 0,        posY: 0,        posZ: 0,
      rotXDeg: 0,     rotYDeg: 0,     rotZDeg: 0,
      scale: 1,
      localOffX: 0,   localOffY: 0,   localOffZ: 0,
    },

    { // 1 – chomo_complet_1M3_V3_hollowed
      url:        "./assets/chomo/models/chomo_complet_1M3_V3.compressed.ply",
      posX: 0,        posY: 0,        posZ: 0,
      rotXDeg: 0,     rotYDeg: 0,     rotZDeg: 0,
      scale: 1,
      localOffX: 0,   localOffY: 0,   localOffZ: 0,
    },

    { // 2 – refuge_ext_int
      url:        "./assets/chomo/models/kit/refuge_ext_int.compressed.ply",
      posX: -1.3122,  posY: 2.4006,   posZ: 6.3302,
      rotXDeg: -2.07, rotYDeg: -85.83, rotZDeg: 0,
      scale: 1,
      localOffX: 0.587755, localOffY: -2.545101, localOffZ: -1.340775,
    },

    { // 3 – refuge_fondations
      url:        "./assets/chomo/models/kit/refuge_fondations.compressed.ply",
      posX: p.x,      posY: p.y,      posZ: p.z,
      rotXDeg: r.x,   rotYDeg: r.y,   rotZDeg: r.z,
      scale: 1,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },

    { // 4 – refuge_structure_ext_int
      url:        "./assets/chomo/models/kit/refuge_structure_ext_int.compressed.ply",
      posX: p.x,      posY: p.y,      posZ: p.z,
      rotXDeg: r.x,   rotYDeg: r.y,   rotZDeg: r.z,
      scale: 1,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },

    { // 5 – refuge_charpente
      url:        "./assets/chomo/models/kit/refuge_charpente.compressed.ply",
      posX: p.x,      posY: -0.059,   posZ: -0.0382,
      rotXDeg: r.x,   rotYDeg: r.y,   rotZDeg: r.z,
      scale: 1.086,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },

    { // 6 – refuge_structure_ext
      url:        "./assets/chomo/models/kit/refuge_structure_ext.compressed.ply",
      posX: p.x,      posY: p.y,      posZ: p.z,
      rotXDeg: r.x,   rotYDeg: r.y,   rotZDeg: r.z,
      scale: 1,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },

    { // 7 – refuge_roof
      url:        "./assets/chomo/models/kit/refuge_roof.compressed.ply",
      posX: p.x,      posY: p.y,      posZ: p.z,
      rotXDeg: r.x,   rotYDeg: r.y,   rotZDeg: r.z,
      scale: 1,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },

    { // 8 – refuge_structure_int
      url:        "./assets/chomo/models/kit/refuge_structure_int.compressed.ply",
      posX: p.x,      posY: p.y,      posZ: p.z,
      rotXDeg: r.x,   rotYDeg: r.y,   rotZDeg: r.z,
      scale: 1,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },
    
    { // 9 – EDP_int_ext
      url:        "./assets/chomo/models/kit/EDP_int_ext.sog",
      posX: p_edp.x,  posY: p_edp.y,  posZ: p_edp.z,
      rotXDeg: r_edp.x, rotYDeg: r_edp.y, rotZDeg: r_edp.z,
      scale: s_edp,
      localOffX: o_edp.x, localOffY: o_edp.y, localOffZ: o_edp.z,
    },

    { // 10 – EDP_fondations_ext_int
      url:        "./assets/chomo/models/kit/EDP_fondations_ext_int.sog",
      posX: p_edp.x,  posY: p_edp.y,  posZ: p_edp.z,
      rotXDeg: r_edp.x, rotYDeg: r_edp.y, rotZDeg: r_edp.z,
      scale: s_edp,
      localOffX: o_edp.x, localOffY: o_edp.y, localOffZ: o_edp.z,
    },
  
    { // 11 – EDP_structure_int_ext
      url:        "./assets/chomo/models/kit/EDP_structure_int_ext.sog",
      posX: p_edp.x,  posY: p_edp.y,  posZ: p_edp.z,
      rotXDeg: r_edp.x, rotYDeg: r_edp.y, rotZDeg: r_edp.z,
      scale: s_edp,
      localOffX: o_edp.x, localOffY: o_edp.y, localOffZ: o_edp.z,
    },

    { // 12 – EDP_ext_walls
      url:        "./assets/chomo/models/kit/EDP_ext_walls.sog",
      posX: p_edp.x,  posY: p_edp.y,  posZ: p_edp.z,
      rotXDeg: r_edp.x, rotYDeg: r_edp.y, rotZDeg: r_edp.z,
      scale: s_edp,
      localOffX: o_edp.x, localOffY: o_edp.y, localOffZ: o_edp.z,
    },

    { // 13 - Sanct_int_ext
      url:        "./assets/chomo/models/kit/sanct_int_ext.sog",
      posX: p_san.x,  posY: p_san.y,  posZ: p_san.z,
      rotXDeg: r_san.x, rotYDeg: r_san.y, rotZDeg: r_san.z,
      scale: s_san,
      localOffX: o_san.x, localOffY: o_san.y, localOffZ: o_san.z,
    },

    { // 14 - Sanct_fondations_int_ext
      url:        "./assets/chomo/models/kit/sanct_fondations_int_ext.sog",
      posX: p_san.x,  posY: p_san.y,  posZ: p_san.z,
      rotXDeg: r_san.x, rotYDeg: r_san.y, rotZDeg: r_san.z,
      scale: s_san,
      localOffX: o_san.x, localOffY: o_san.y, localOffZ: o_san.z,
    },

    { // 15 - Sanct_fond
      url:        "./assets/chomo/models/kit/sanct_fond.sog",
      posX: p_san.x,  posY: p_san.y,  posZ: p_san.z,
      rotXDeg: r_san.x, rotYDeg: r_san.y, rotZDeg: r_san.z,
      scale: s_san,
      localOffX: o_san.x, localOffY: o_san.y, localOffZ: o_san.z,
    },

    { // 16 - Sanct_structure_int_ext
      url:        "./assets/chomo/models/kit/sanct_structure_int_ext.sog",
      posX: p_san.x,  posY: p_san.y,  posZ: p_san.z,
      rotXDeg: r_san.x, rotYDeg: r_san.y, rotZDeg: r_san.z,
      scale: s_san,
      localOffX: o_san.x, localOffY: o_san.y, localOffZ: o_san.z,
    },

    { // 17 - Sanct_structure_int_ext_cut
      url:        "./assets/chomo/models/kit/sanct_structure_int_ext_cut.sog",
      posX: p_san.x,  posY: p_san.y,  posZ: p_san.z,
      rotXDeg: r_san.x, rotYDeg: r_san.y, rotZDeg: r_san.z,
      scale: s_san,
      localOffX: o_san.x, localOffY: o_san.y, localOffZ: o_san.z,
    },

    { // 18 - maison_fondations
      url:        "./assets/chomo/models/kit/maison_fondations.sog",
      posX: p_mai.x,  posY: p_mai.y,  posZ: p_mai.z,
      rotXDeg: r_mai.x, rotYDeg: r_mai.y, rotZDeg: r_mai.z,
      scale: s_mai,
      localOffX: o_mai.x, localOffY: o_mai.y, localOffZ: o_mai.z,
    },

    { // 19 - maison_murs
      url:        "./assets/chomo/models/kit/maison_murs.sog",
      posX: p_mai.x,  posY: p_mai.y,  posZ: p_mai.z,
      rotXDeg: r_mai.x, rotYDeg: r_mai.y, rotZDeg: r_mai.z,
      scale: s_mai,
      localOffX: o_mai.x, localOffY: o_mai.y, localOffZ: o_mai.z,
    },

    { // 20 - maison_toit
      url:        "./assets/chomo/models/kit/maison_toit.sog",
      posX: p_mai.x,  posY: p_mai.y,  posZ: p_mai.z,
      rotXDeg: r_mai.x, rotYDeg: r_mai.y, rotZDeg: r_mai.z,
      scale: s_mai,
      localOffX: o_mai.x, localOffY: o_mai.y, localOffZ: o_mai.z,
    },
    
    { // 21 - maison_ext
      url:        "./assets/chomo/models/kit/maison_ext.sog",
      posX: p_mai.x,  posY: p_mai.y,  posZ: p_mai.z,
      rotXDeg: r_mai.x, rotYDeg: r_mai.y, rotZDeg: r_mai.z,
      scale: s_mai,
      localOffX: o_mai.x, localOffY: o_mai.y, localOffZ: o_mai.z,
    },
    
    { // 22 - 2cv
      url:        "./assets/chomo/models/kit/citroen-2cv.glb",
      posX: p.x,  posY: p.y,  posZ: p.z,
      rotXDeg: r.x, rotYDeg: r.y, rotZDeg: r.z,
      scale: 1,
      localOffX: o.x, localOffY: o.y, localOffZ: o.z,
    },  
  ];

  // ── Reconstruction dynamique des arrays attendus par spark_viewer_v2.js ──
  const models       = modelDefs.map(m => m.url);
  const modelsAmount = models.length;

  const config_models = {
    lieuCible:    null,
    meshURL:      null,
    meshPropsURL: "./assets/chomo/models/kit/cars.glb",
    planURL:      './assets/chomo/plans/plan_topo_chomo.svg',
    curvesURL:     './assets/chomo/plans/chomo_topo_sans_plan3.svg',
    modelsAmount,
    modelURL:     models,

    camPosX: -15,   camPosY: 14,    camPosZ: -21,
    camRotX: -2,    camRotY: 0,     camRotZ: -3,
    camTargetX: 0.2, camTargetY: 0, camTargetZ: 0,
    camMinDistance: 0.1,
    camMaxDistance: 1000,
    camDampingFactor: 1,

    bgColor: "#ffffff",

    modelPosX:      modelDefs.map(m => m.posX),
    modelPosY:      modelDefs.map(m => m.posY),
    modelPosZ:      modelDefs.map(m => m.posZ),
    modelRotXDeg:   modelDefs.map(m => m.rotXDeg),
    modelRotYDeg:   modelDefs.map(m => m.rotYDeg),
    modelRotZDeg:   modelDefs.map(m => m.rotZDeg),
    modelScale:     modelDefs.map(m => m.scale),
    modelLocalOffX: modelDefs.map(m => m.localOffX),
    modelLocalOffY: modelDefs.map(m => m.localOffY),
    modelLocalOffZ: modelDefs.map(m => m.localOffZ),
  };



  // ── Plan ────────────────────────────────────────────────────
  const config_plan = {
    showPlan:           false,
    planMeshInFront:    false,
    planScale:          1,
    planMaterialOpacity: 1.0,
    planPosX:  -0.917999999999992,
    planPosY:  0,
    planPosZ:  34.2102,
    planRotX:  -90,
    planRotY:  0,
    planRotZ:  96.0306
  };

    // ── props ────────────────────────────────────────────────────
  const config_props = {
    enableProps:         true,
    showProps:           true,
    propsScale:          0.55,
    propsMaterialOpacity: 1.0,
    propsPosX:  13.8,
    propsPosY:  0.1,
    propsPosZ:  89.5,
    propsRotX:  0,
    propsRotY:  0,
    propsRotZ:  0
  };

  // ── Courbes (Topographic Curves) ─────────────────────────
  const config_curves = {
    enableCurves: true,
    showCurves: true,
    elevation_step: 6.2,        // Vertical spacing between each contour line (Three.js units)
    curves_scale: 0.047551,
    curvesWidth: 2,
    curvesPosX:   -18.1428,
    curvesPosY:   3.8,
    curvesPosZ:   127.5202,
    curvesRotX:   91.0408,
    curvesRotY:   0,
    curvesRotZ:  -96.0306

  };
  

  const config_interface = {
  showInterface: true,
  showCross: false
};
  // ═══════════════════════════════════════════════════════════════

  import { initViewer } from './spark_viewer_v2.js';
  initViewer({ ...config_models, ...config_plan, ...config_props, ...config_curves, ...config_interface });
